<template>
  <div>
    <p class="title">
      {{ $i18n.t('reset-pwd') }}
    </p>
    <!-- <p class="subtitle">We have increased password security.</p> -->
    <p class="desc">{{ $i18n.t('forgetpsw-email-desc') }}</p>
    <div class="form-box">
      <div class="login-formitem-group">
        <div class="form-item-label">
          <label for="email">{{ $i18n.t('mbs-email') }}*</label>
        </div>
        <div class="new-password-input">
          <input
            class="form-item-input fs-mask"
            :class="{ 'input-border-err': validateErr }"
            type="text"
            name="email"
            id="email"
            autocomplete="new-password"
            role="input email"
            v-model.trim="email"
            @input="handleEmailChange"
          />
        </div>
      </div>
      <!-- 错误提示 -->
      <p v-if="validateErr" class="error-message">{{ $i18n.t('error-valid-email') }}</p>
      <p v-if="errEmailMsg" class="error-message">{{ errEmailMsg }}</p>
    </div>
    <div class="button">
      <div class="login-btn" :class="{ 'login-btn-disable': loginDisable }">
        <div v-if="!loading" @click="handleSend" role="button">
          {{ $i18n.t('forgetpsw-send-code') }}
        </div>
        <img v-else class="btn-loading" src="~img/loading.gif" alt="" />
      </div>
    </div>
  </div>
</template>
<script lang="js">
  // const emailReg = /(?!.*con$)\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
  export default {
    name: 'ForgetPsw',
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      errEmailMsg: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        validateErr: false,
        loginDisable: true,
        email: '',
      };
    },
    methods: {
      handleEmailChange(e) {
        const { value } = e.target;
        if (value) {
          this.validateErr = false;
          this.loginDisable = false;
          this.$emit('update:errEmailMsg', '');
        } else {
          this.validateErr = true;
          this.loginDisable = true;
        }
      },
      handleSend() {
        if (this.validateErr || this.loginDisable) return;
        this.$emit('handleSend', this.email);
      },
    },
  };
</script>
<style lang="scss" scoped>
  @use '@/assets/css/variables.scss' as *;
  .title {
    @include font(32px, 700);
    line-height: 44px;
    margin-bottom: 30px;
    text-align: center;
  }

  /*   .subtitle {
    @include font(18px, 700);
    margin-bottom: 5px;
    text-align: center;
  } */

  .desc {
    @include font(18px, 400);
    /* prettier-ignore */
    font-size: min(14Px);
    margin-bottom: 5px;
    text-align: center;
    width: 450px;
    margin: auto;
    line-height: 25px;
  }

  .button {
    width: 450px;
    margin: 30px auto;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .form-box {
    width: 450px;
    margin: 30px auto;
    .form-item-label {
      @include font(18px, 600);
      /* prettier-ignore */
      font-size: min(14Px);
      line-height: 22px;
      margin-bottom: 7px;
      white-space: nowrap;
    }
    .form-item-input {
      box-sizing: border-box;
      width: 100%;
      height: 58px;
      padding: 12px 12px;
      line-height: 34px;
      border: 2px solid #bec7cc;
      border-radius: 10px;
      color: #163049;
      @include font(18px, 400);
      /* prettier-ignore */
      font-size: min(14Px);
      @include beauty-placeholder(24px, #cad1d6);

      &.input-border-err {
        border-color: $color-red;
      }

      &:-webkit-autofill {
        line-height: 34px;

        @include font(24px, 400);
      }

      &:-internal-autofill-selected {
        color: #163049 !important;
        @include font(18px, 400);
        /* prettier-ignore */
        font-size: min(14Px);
      }
    }

    .login-formitem-group {
      position: relative;
    }

    .new-password-input {
      position: relative;
      // margin-bottom: 16px;
    }
  }

  .login-btn {
    @include font(24px, 600);
    /* prettier-ignore */
    font-size: min(14Px);
    cursor: pointer;
    display: inline-block;
    width: 100%;
    height: 58px;
    line-height: 58px;
    color: #fff;
    text-align: center;
    background: $color-glod-radient;
    border-radius: 10px;

    &-disable {
      cursor: not-allowed;
      background: #9eacb5;
    }
  }

  .error-message {
    @include font(20px, 400);
    /* prettier-ignore */
    font-size: min(14Px);
    width: 450px;
    text-align: start;
    margin: 0 auto;
    margin-top: 16px;
    line-height: 27px;
    color: #c22;
    word-wrap: break-word;
    //word-break: break-all;
  }

  @media screen and (max-width: 1024px) {
    .desc {
      width: 100%;
    }
    .form-box {
      width: 100%;
      margin: 15px auto;

      .error-message {
        @include font(14px, 400);
        width: 100%;
      }
    }
    .button {
      width: 100%;
    }
  }
</style>
